const root = `td-system/dept/`
const urls = {
  getList: root + 'list',
  getPage: root + 'page',
  remove: root + 'remove',
  add: root + 'save',
  detail: root + 'show-info',
  update: root + 'update',
  submit: root + 'submit-info'
}

// 获取列表页数据
export const getList = obj => {
  return $http.get(urls.getList, obj)
}
// 获取列表页数据
export const getPage = obj => {
  return $http.get(urls.getPage, obj)
}
// 删除列表中目标数据
export const remove = obj => {
  let ids = Array.isArray(obj) ? obj.map(z => z.id).join(',') : obj.id
  return $http.post(`${urls.remove}?ids=${ids}`)
}

export const add = obj => {
  return $http.post(urls.add, obj)
}
export const detail = id => {
  return $http.get(urls.detail, { id: id })
}
export const update = obj => {
  return $http.post(urls.update, obj)
}
export const submit = obj => {
  return $http.post(urls.submit, obj)
}

export default {
  add,
  update,
  detail,
  getList,
  remove,
  submit,
  getPage
}
